'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _performanceNow = require('./vendor/performanceNow');

var _performanceNow2 = _interopRequireDefault(_performanceNow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastArg = null;
var lastResult = null;

exports.default = function (history) {
  if (history === lastArg) {
    return lastResult;
  }

  (0, _invariant2.default)(!!history.getCurrentLocation, 'Must supply a `history@3` object');

  var _history$getCurrentLo = history.getCurrentLocation(),
      initialPathname = _history$getCurrentLo.pathname;

  lastArg = history;
  lastResult = {
    pathname: initialPathname,
    listen: function listen(cb) {
      return history.listen(function (_ref) {
        var pathname = _ref.pathname;

        var timestamp = (0, _performanceNow2.default)();
        cb({
          timestamp: timestamp,
          pathname: pathname
        });
      });
    }
  };

  return lastResult;
};

module.exports = exports['default'];